import React, { useCallback } from "react";
import { Card, Dropdown } from "semantic-ui-react";
import { convertToDollar } from "../../../Helpers";
import { IHomeDrawRequestsObj } from "../../interfaces/Borrower";
import { useHistory } from "react-router-dom";

interface IBWDrawRequestCard {
  drawRequest: IHomeDrawRequestsObj;
  index: string | number;
  setIsDeleteDrawModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedLoanDrawId: React.Dispatch<React.SetStateAction<string>>;
}

const BWDrawRequestCard = ({drawRequest, index, setIsDeleteDrawModalOpen, setSelectedLoanDrawId}: IBWDrawRequestCard) => {
  const history = useHistory();
  const handleToLoanDrawDetails = useCallback((id) => {
    history.push(`/loandrawdetail/${id}`, { "loanId": drawRequest.id, "loan": drawRequest.loan, "loanProperty": drawRequest.loanProperty});
  }, [history]);

  const handleDeleteLoanDrawRequest = (drawReqestId) => {
    setIsDeleteDrawModalOpen(true);
    setSelectedLoanDrawId(drawReqestId);
  };

  return (
    <React.Fragment>
      <Card key={"draw-request-content-card-" + index}>
        <Card.Content>
          <div className="card-header-custom">
            <div className="card-header-title-custom">{drawRequest.name}</div>
            <div>
              <Dropdown key="card-dropdown" className="icon landing-page-card-header-icon" icon="ellipsis vertical" pointing="top right">
                <Dropdown.Menu key="card-menu" className="borrower-home borrower-draw-request-transform">
                  <Dropdown.Item key="download-draw-management" onClick={() => console.log("Download Draw Management")}>Download Draw Management</Dropdown.Item>
                  {drawRequest.loanDrawApplicationStatus === "Pending" ? <React.Fragment>
                    {/* TODO: functionality for all dropdown items */}
                    <Dropdown.Item key="resume" onClick={() => handleToLoanDrawDetails(drawRequest.id)}>Resume</Dropdown.Item>
                    <Dropdown.Item key="delete" onClick={() => handleDeleteLoanDrawRequest(drawRequest.id)}>Delete</Dropdown.Item>
                    </React.Fragment>
                  : <React.Fragment>
                    <Dropdown.Item key="download-inspection-report" onClick={() => console.log("Download Inspection Report")}>Download Inspection Report</Dropdown.Item>
                    <Dropdown.Item key="view" onClick={() => console.log("View")}>View</Dropdown.Item>
                  </React.Fragment>}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <Card.Description>
            <div><strong>{drawRequest.loan} - {drawRequest.loanProperty}</strong></div>
            <div><strong>Requested Amount:</strong> {convertToDollar(drawRequest.drawRequestAmount)}</div>
            <div><strong>Approved Amount:</strong> <span>{convertToDollar(drawRequest.approvedAmount)}</span></div>
            <div><strong>Inspection Scheduled:</strong>{drawRequest.loanDrawApplicationStatus} {drawRequest.inspectionStatus ? `(${drawRequest.inspectionStatus})` : ""}</div>
          </Card.Description>
        </Card.Content>
      </Card>
    </React.Fragment>
  );
};

export default BWDrawRequestCard;